module.exports = __webpack_public_path__ + "static/1-f68d00489c33b561b4fbafd0c5980125.png";